import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, firstValueFrom, from, Observable } from "rxjs";
import { ModifyJobbRequestDTO } from "~app/common/models/common/ModifyJobbRequestDTO";
import { ModifyJobbResponseDTO } from "~app/common/models/common/ModifyJobbResponseDTO";
import { SchemalaggRequestDTO } from "~app/common/models/common/SchemalaggRequestDTO";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ISchemalaggningDetail, ISchemalaggningListDetail, LastEntriesForJobbtypViewModel } from "./schemalaggning.models";

@Injectable({
    providedIn: "root"
})
export class SchemalaggningService {
    currentHistory$: BehaviorSubject<ISchemalaggningDetail[]>;
    currentSchemalaggningar$: BehaviorSubject<ISchemalaggningListDetail[]>;
    jobbList$: BehaviorSubject<LastEntriesForJobbtypViewModel[]>;

    private readonly apiClient = inject(ApiClientService);

    constructor() {
        this.currentSchemalaggningar$ = new BehaviorSubject<ISchemalaggningListDetail[]>([]);
        this.currentHistory$ = new BehaviorSubject<ISchemalaggningDetail[]>([]);
        this.jobbList$ = new BehaviorSubject<LastEntriesForJobbtypViewModel[]>([]);
    }

    checkJobbNotProcessed(jobbNamn: string): Promise<number> {
        const jobbtyp = jobbNamn.replace("ProcessJobbQueue", "");
        return firstValueFrom(this.apiClient.get<number>(`administration/modifyjobb/jobbnotprocessed?jobbtyp=${jobbtyp}`, false));
    }

    getHistory(jobbNamn: string): void {
        this.apiClient.get<ISchemalaggningDetail[]>(`RaskCommon/GetSchemaHistory?jobbNamn=${jobbNamn}`, true)
            .subscribe(x => {
                this.currentHistory$.next(x);
            });
    }

    getJobbList(jobbNamn: string): void {
        const jobbtyp = jobbNamn.replace("ProcessJobbQueue", "");
        this.apiClient.get<LastEntriesForJobbtypViewModel[]>(`administration/modifyjobb/listajobbtyp?jobbtyp=${jobbtyp}`, false)
            .subscribe(x => {
                this.jobbList$.next(x);
            });
    }

    modifyJobbStatus(jobbnamn: string, jobbstatus: string): Observable<ModifyJobbResponseDTO> {
        return this.apiClient.post<ModifyJobbRequestDTO, ModifyJobbResponseDTO>("administration/modifyjobb/jobb", { jobbNamn: jobbnamn,
            jobbStatus: jobbstatus }, false);
    }

    refreshSchemalaggningar(): void {
        this.apiClient.get<ISchemalaggningListDetail[]>("RaskCommon/GetAllSchemalaggningar", true)
            .subscribe(x => {
                this.currentSchemalaggningar$.next(x);
            });
    }

    schemalagg(jobbNamn: string): Observable<void> {
        return from(firstValueFrom(this.apiClient.post<SchemalaggRequestDTO, void>("RaskCommon/schemalagg", { jobbNamn: jobbNamn }, true))
            .then(x => {
                this.refreshSchemalaggningar();
            }));
    }
}
